import {
  AfterViewInit,
  Component,
  OnInit,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { ContentComponent } from './layout/content/content.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { PrimeNGConfig } from 'primeng/api';
const bgLocale = {
  accept: 'Да',
  addRule: 'Добавяне на условие',
  am: 'AM',
  apply: 'Приложи',
  cancel: 'Отказ',
  choose: 'Избор',
  chooseDate: 'Изберете Дата',
  chooseMonth: 'Изберете месец',
  chooseYear: 'Изберете година',
  clear: 'Изчистване',
  completed: 'Завършено',
  contains: 'Съдържа',
  custom: 'Персонализиран',
  dateAfter: 'Датата е след',
  dateBefore: 'Датата е преди',
  dateFormat: 'dd/mm/yy',
  dateIs: 'Датата е',
  dateIsNot: 'Дататата не е',
  dayNames: [
    'Неделя',
    'Понеделник',
    'Вторник',
    'Сряда',
    'Четвъртък',
    'Петък',
    'Събота',
  ],
  dayNamesMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  dayNamesShort: ['Нед', 'Пон', 'Вто', 'Сря', 'Чет', 'Пет', 'Съб'],
  emptyFilterMessage: 'Няма налична информация',
  emptyMessage: 'Не са открити резултати',
  emptySearchMessage: 'Няма намерени резултати',
  emptySelectionMessage: 'Няма избран елемент',
  endsWith: 'Завършва на',
  equals: 'Равно е на',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  filter: 'Филтър',
  firstDayOfWeek: 1,
  gt: 'По-голямо от',
  gte: 'По-голямо или равно на',
  lt: 'По-малко от',
  lte: 'По-малко или равно на',
  matchAll: 'Съвпадение на всички',
  matchAny: 'Съвпадение на някое ',
  medium: 'Средна',
  monthNames: [
    'Януари',
    'Февруари',
    'Март',
    'Април',
    'Май',
    'Юни',
    'Юли',
    'Август',
    'Септември',
    'Октомври',
    'Ноември',
    'Декември',
  ],
  monthNamesShort: [
    'Яну',
    'Фев',
    'Мар',
    'Апр',
    'Май',
    'Юни',
    'Юли',
    'Авг',
    'Сеп',
    'Окт',
    'Ное',
    'Дек',
  ],
  nextDecade: 'Следващото десетилетие',
  nextHour: 'Следващият час',
  nextMinute: 'Следващата минута',
  nextMonth: 'Следващият месец',
  nextSecond: 'Следваща секунда',
  nextYear: 'Следващата година',
  noFilter: 'Без филтър',
  notContains: 'Не съдържа',
  notEquals: 'Не е равно на',
  now: 'Сега',
  passwordPrompt: 'Въведете парола',
  pending: 'В очакване',
  pm: 'PM',
  prevDecade: 'Предишното десетилетие',
  prevHour: 'Предишен час',
  prevMinute: 'Предишна минута',
  prevMonth: 'Предишния месец',
  prevSecond: 'Предишен втори',
  prevYear: 'Предходната година',
  reject: 'Не',
  removeRule: 'Премахване на условие',
  searchMessage: 'Налични са {0} резултата',
  selectionMessage: '{0} избрани елемента',
  showMonthAfterYear: false,
  startsWith: 'Започва с',
  strong: 'Добра',
  today: 'Днес',
  upload: 'Качване',
  weak: 'Слаба',
  weekHeader: 'Сд',
  aria: {
    cancelEdit: 'Отказ Редактиране',
    close: 'Близо',
    collapseLabel: 'Свиване',
    collapseRow: 'Редът е свит',
    editRow: 'Редактиране на ред',
    expandLabel: 'Разширяване',
    expandRow: 'Редът е разширен',
    falseLabel: 'Невярно',
    filterConstraint: 'Ограничение на филтъра',
    filterOperator: 'Филтър оператор',
    firstPageLabel: 'Първа страница',
    gridView: 'Мрежов изглед',
    hideFilterMenu: 'Скриване на менюто за филтриране',
    jumpToPageDropdownLabel: 'Отидете до падащото меню на страницата',
    jumpToPageInputLabel: 'Преминете към Въвеждане на страница',
    lastPageLabel: 'Последна страница',
    listView: 'Списъчен изглед',
    moveAllToSource: 'Преместете всички в източника',
    moveAllToTarget: 'Преместете всички в целта',
    moveBottom: 'Преместване на дъното',
    moveDown: 'Преместване надолу',
    moveTop: 'Преместване отгоре',
    moveToSource: 'Преместване към източника',
    moveToTarget: 'Преместете се в Target',
    moveUp: 'Преместване нагоре',
    navigation: 'Навигация',
    next: 'Следващия',
    nextPageLabel: 'Следваща страница',
    nullLabel: 'Не е избрано',
    otpLabel: 'Моля, въведете еднократна парола {0}',
    pageLabel: 'Страница {страница}',
    passwordHide: 'Скриване на паролата',
    passwordShow: 'Покажи парола',
    previous: 'Предишен',
    previousPageLabel: 'Предишна страница',
    rotateLeft: 'Завърти наляво',
    rotateRight: 'Завъртане надясно',
    rowsPerPageLabel: 'Редове на страница',
    saveEdit: 'Запазване на редактирането',
    scrollTop: 'Превъртете отгоре',
    selectAll: 'Всички избрани елементи',
    selectLabel: 'Изберете',
    selectRow: 'Избран ред',
    showFilterMenu: 'Показване на менюто за филтриране',
    slide: 'пързалка',
    slideNumber: '{slideNumber}',
    star: '1 звезда',
    stars: '{star} звезди',
    trueLabel: 'Вярно',
    unselectAll: 'Всички елементи са премахнати',
    unselectLabel: 'Премахване на избора',
    unselectRow: 'Редът не е избран',
    zoomImage: 'Увеличете изображението',
    zoomIn: 'Увеличавам',
    zoomOut: 'Отдалечавам',
  },
};
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    ContentComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'angular-dashboard';
  platformId = inject(PLATFORM_ID);
  isBrowser = isPlatformBrowser(this.platformId);
  primeNGConfig = inject(PrimeNGConfig);
  router = inject(Router);
  ngOnInit(): void {
    if (!this.isBrowser) return;
    this.router.events.subscribe({
      next: (event) => {
        if (event instanceof NavigationEnd) {
          console.log(event);
        }
      },
    });
    initFlowbite();
    this.primeNGConfig.setTranslation(bgLocale);
  }
  ngAfterViewInit(): void {}
}
